// 简体中文翻译文件
export default {
  // 日期本地化代码
  locale: "zh-CN",

  // 首页
  home: {
    hero: {
      title: "课程点评导航",
      subtitle:
        "新学期选课，还在「开盲盒」？\n教授是「天使」还是「杀手」？\n课比三家，才不挂科！",
      getStarted: "马上体验",
      browseCourses: "浏览课程",
      registerNow: "立即注册，完全免费",
    },
    stats: {
      courses: "课程",
      reviews: "点评",
      users: "用户",
    },
    userJourney: {
      title: "解锁无限访问的两种方式",
      subtitle:
        "选择合适的路径，解锁全部高级功能，和大家一起建设口碑库",
      or: "或",
      premiumOffer: {
        title: "🎁 两条通往高级权限的捷径",
        description:
          "写点评即可领取 30 天无限访问；邀请好友则直接拿下整整一年！",
      },
      pathReview: {
        title: "撰写点评",
        description:
          "分享你的真实上课体验，每写一条点评都能再获得 30 天无限浏览资格。",
        benefit: "每条点评 +30 天",
        step1: "免费注册",
        step2: "找到课程",
        step3: "写点评赚天数",
        action: "开始写点评",
      },
      pathInvite: {
        title: "邀请好友",
        description:
          "把邀请码发给好友，他们注册并写下第一条点评后，你们双方都能直接解锁 1 年高级权限。",
        benefit: "双方各得 1 年",
        step1: "免费注册",
        step2: "分享邀请码",
        step3: "一起享 1 年",
        action: "获取邀请码",
      },
      step1: {
        title: "加入社区",
        description:
          "注册账号即可解锁全部功能，与全国高校同学随时交流——完全免费。",
        action: "立即注册",
      },
      step2: {
        title: "浏览课程",
        description:
          "覆盖全德高校课程，搭配强大筛选器，快速找到想了解的课。",
        action: "探索课程",
      },
      step3: {
        title: "看看真心话",
        description:
          "来自真实选课同学的第一手体验，帮助你避雷、挑对老师。",
        limitNote:
          "⚠️ 未贡献点评前只能查看 10 条，写点评即可打破限制。",
        action: "查看点评",
      },
      step4: {
        title: "分享再拿 30 天",
        description:
          "每写一条点评就延长 30 天无限访问，坚持分享就能一直免费看。",
        benefit: "每条点评 +30 天",
        action: "写点评",
      },
      demo: {
        title: "一分钟了解玩法",
      },
    },
    features: {
      title: "为什么选择 KursKompass？",
      subtitle: "选课决策必备信息，这里一网打尽",
      authentic: {
        title: "真实点评",
        description: "来自在读学生的真实评分与心得，少走弯路不踩坑。",
      },
      search: {
        title: "智能搜索",
        description: "灵活组合筛选条件，几秒钟定位到想要的课程。",
      },
      analysis: {
        title: "洞察分析",
        description: "可视化统计与趋势图，帮助你做出更有底气的选择。",
      },
      community: {
        title: "活力社区",
        description: "成千上万学生正在分享经验，一起抱团取暖。",
      },
    },
    popularCourses: {
      title: "热门课程",
      reviewsLabel: "条点评",
      noData: "暂无热门课程数据",
    },
    quickStart: {
      title: "快速上手",
      step1: {
        title: "创建账号",
        description: "注册个人账号即可使用全部功能。",
        action: "立即注册",
      },
      step2: {
        title: "挑课",
        description: "浏览高校与课程列表，锁定你感兴趣的课。",
        action: "浏览课程",
      },
      step3: {
        title: "看点评",
        description: "阅读同学们的真实反馈，掌握课堂细节。",
        action: "查看数据",
      },
      step4: {
        title: "写分享",
        description: "留下你的上课心得，帮助后来人选对课。",
        action: "开始点评",
      },
    },
  },

  // 通用
  common: {
    search: "搜索",
    login: "登录",
    logout: "退出登录",
    register: "注册",
    submit: "提交",
    cancel: "取消",
    save: "保存",
    edit: "编辑",
    delete: "删除",
    confirm: "确认",
    loading: "加载中…",
    success: "成功",
    error: "错误",
    warning: "提醒",
    info: "信息",
    home: "首页",
    back: "返回",
    next: "下一步",
    previous: "上一步",
    yes: "是",
    no: "否",
    active: "已启用",
    ok: "好的",
    notAvailable: "暂无",
    close: "关闭",
    refresh: "刷新",
    reset: "重置",
    clear: "清空",
    selectAll: "全选",
    deselectAll: "取消全选",
    language: "语言",
    anonymousUser: "匿名用户",
    theme: "主题",
    settings: "设置",
    help: "帮助",
    about: "关于",
    contact: "联系",
    feedback: "反馈",
    version: "版本",
    update: "更新",
    download: "下载",
    upload: "上传",
    import: "导入",
    export: "导出",
    print: "打印",
    share: "分享",
    copy: "复制",
    paste: "粘贴",
    cut: "剪切",
    undo: "撤销",
    redo: "重做",
    footerDescription: "德国高校课程点评平台",
    showLess: "收起",
    readMore: "展开",
    skipForNow: "暂时跳过",
    bookmarked: "已收藏",
    remove: "移除",
    retry: "重试",
    retrySuccess: "重试成功",
    retryFailed: "重试失败，请稍后再试",
    backToHome: "返回首页",
    since: "自",
    today: "今天",
    yesterday: "昨天",
    daysAgo: "{days} 天前",
    loadError: "数据加载失败",
  },

  // 导航
  nav: {
    title: "KursKompass",
    home: "首页",
    courses: "课程",
    universities: "院校",
    reviews: "点评",
    recommendations: "推荐",
    stats: "数据",
    trending: "热门",
    profile: "我的",
    settings: "设置",
    login: "登录",
    register: "注册",
    logout: "退出",
    addCourse: "新增课程",
    myInvitationCode: "我的邀请码",
    cancel: "取消",
    logoutConfirmMessage: "确定要退出当前账号吗？",
    logoutConfirmTitle: "退出确认",
    logoutConfirm: "退出登录",
    logoutSuccess: "已成功退出",
  },

  // 热门页面
  trending: {
    subtitle: "发现你所在院校最受欢迎、评分最高的课程",
    topRated: "高分课程",
    mostReviewed: "热门点评",
    avgRatingSort: "按平均分排序",
    reviewCountSort: "按点评数量排序",
    noData: "暂无课程数据",
    noUniversity: "尚未选择院校",
    noUniversityDesc: "请先在个人资料中选择院校，才能查看该校热门课程",
    pleaseSelectUniversity: "请先选择一所院校",
  },

  // 账号体系
  auth: {
    welcome: "欢迎来到 KursKompass",
    loginTitle: "登录",
    registerTitle: "加入聪明选课阵营",
    registerSubtitle: "别再盲选课，让真实口碑帮你决定！",
    noAccount: "还没有账号？",
    hasAccount: "已有账号？",
    signUp: "注册",
    signIn: "登录",
    loginNow: "马上登录",
    username: "用户名",
    email: "邮箱",
    password: "密码",
    confirmPassword: "确认密码",
    fullName: "姓名",
    firstName: "名",
    lastName: "姓",
    phoneNumber: "手机号",
    dateOfBirth: "出生日期",
    gender: "性别",
    male: "男",
    female: "女",
    other: "其他",
    loginSuccess: "登录成功",
    loginFailed: "登录失败",
    registerSuccess: "注册成功",
    registerFailed: "注册失败",
    logoutSuccess: "退出成功",
    confirmLogout: "确定要退出登录吗？",
    sessionExpired: "登录已过期，请重新登录",
    accessDenied: "无权访问",
    networkError: "网络异常，请检查连接",
    login: {
      title: "登录",
      welcomeBack: "欢迎回来",
      subtitle: "登录你的 KursKompass 账号",
      username: "用户名",
      password: "密码",
      usernamePlaceholder: "用户名或邮箱",
      passwordPlaceholder: "密码",
      loginButton: "登录",
      rememberMe: "下次自动登录",
      forgotPassword: "忘记密码？",
      noAccount: "还没有账号？",
      registerNow: "立即注册",
      platformTitle: "德国高校课程点评平台",
      platformDescription: "透明真实的课程口碑，助你精准选课",
      features: {
        authentic: "真实点评",
        search: "智能搜索",
        analysis: "数据分析",
      },
      loginSuccess: "登录成功",
      loginFailed: "登录失败",
      emailVerifiedSuccess: "邮箱验证成功！现在可以登录了。",
      emailVerificationFailed: "邮箱验证失败，请重试或联系支持。",
      emailNotVerifiedTitle: "邮箱未验证",
      emailNotVerifiedMessage: "你的邮箱尚未完成验证，是否重新发送验证邮件？",
      resendButton: "重新发送",
      laterButton: "稍后再说",
      validationError: "请检查输入后再试",
      validation: {
        usernameRequired: "请输入用户名或邮箱",
        usernameLength: "长度需在 3-50 个字符之间",
        passwordRequired: "请输入密码",
        passwordLength: "密码至少 6 个字符",
      },
    },
    forgotPassword: {
      title: "忘记密码",
      subtitle: "输入邮箱，我们会帮助你重设密码",
      emailPlaceholder: "输入你的邮箱",
      submitButton: "发送重置邮件",
      backToLogin: "返回登录",
      successMessage: "如果邮箱存在，我们会很快发送重置说明。",
      infoTitle: "密码重置说明",
      infoMessage: "密码找回功能正在完善，紧急情况请联系管理员。",
      validation: {
        emailRequired: "请输入邮箱地址",
        emailInvalid: "请输入合法的邮箱地址",
      },
    },
    register: {
      title: "加入聪明选课阵营",
      subtitle: "别盲选，让学长学姐的经验带你飞！",
      username: "用户名",
      email: "邮箱",
      password: "密码",
      confirmPassword: "确认密码",
      invitationCode: "邀请码（选填）",
      invitationCodeHint: "输入好友的邀请码即可双方各得 1 年高级权限！",
      validate: "验证",
      validating: "验证中…",
      hasAccount: "已有账号？",
      loginNow: "现在登录",
    },
  },

  // 搜索
  search: {
    title: "搜索",
    placeholder: "搜索课程、院校…",
    searchResults: "搜索结果",
    noResults: "没有找到结果",
    popularSearches: "热门搜索",
    pleaseEnterSearchTerm: "请输入搜索词",
    searchFor: "搜索",
    filterByType: "按类型筛选",
    filterByUniversity: "按院校筛选",
    sortBy: "排序",
    relevance: "相关度",
    newest: "最新",
    oldest: "最早",
    rating: "评分",
    name: "名称",
    results: "结果",
    found: "共",
    suggestions: "猜你在找",
    history: "搜索历史",
    clearHistory: "清除历史",
    course: "课程",
    university: "院校",
    courseCode: "课程代码",
    other: "其他",
  },

  // 院校
  universities: {
    title: "院校",
    subtitle: "浏览德国所有高校",
    name: "院校名称",
    location: "所在地",
    city: "城市",
    state: "州/邦",
    established: "创办年份",
    type: "类型",
    ranking: "排名",
    website: "官网",
    description: "简介",
    students: "学生人数",
    faculty: "教职工",
    programs: "课程项目",
    tuition: "学费",
    admissionRate: "录取率",
    graduationRate: "毕业率",
    search: "搜索院校…",
    searchPlaceholder: "按院校名称查找…",
    cityPlaceholder: "选择城市",
    statePlaceholder: "选择州/邦",
    filterByType: "按类型筛选",
    filterByLocation: "按地区筛选",
    filterByRanking: "按排名筛选",
    public: "公立",
    private: "私立",
    technical: "理工类",
    liberal: "人文类",
    research: "研究型",
    comprehensive: "综合性",
    viewDetails: "查看详情",
    viewCourses: "查看课程",
    moreInfo: "更多信息",
    contact: "联系",
    apply: "申请",
    favorites: "收藏夹",
    addToFavorites: "加入收藏",
    removeFromFavorites: "取消收藏",
    compare: "对比",
    addToCompare: "加入对比",
    removeFromCompare: "移出对比",
    clearFilters: "重置筛选",
    searchButton: "搜索",
    coursesAvailable: "共有 {count} 门课程",
    coursesAvailableSingular: "共有 {count} 门课程",
    noData: "暂无院校数据",
    showingResults: "展示 {count} 所院校",
    showingResultsSingular: "展示 {count} 所院校",
    details: {
      name: "名称",
      totalCourses: "课程数量",
    },
    noResults: "没有符合条件的院校",
    loading: "院校数据加载中…",
  },

  // 院校选择
  university: {
    selectYourUniversity: "选择你的院校",
    searchPlaceholder: "按名称、城市或缩写搜索（如 TUM、RWTH、LMU…）",
    searchHint: "💡 试试用院校缩写搜索，例如 TUM、RWTH、KIT、FH",
    selectionHint: "选择院校后，我们才能为你推荐更精准的课程内容。",
    coursesAvailable: "共有 {count} 门课程",
    noResults: "未找到匹配院校",
    fetchError: "院校数据加载失败",
    selectionSuccess: "院校选择成功",
    selectionFailed: "院校选择失败",
    skipForNow: "暂时跳过",
  },

  // 院校切换器
  universitySwitcher: {
    selectUniversity: "选择院校",
    searchPlaceholder: "搜索…",
    current: "当前院校",
    switchTo: "切换至",
    viewAll: "查看全部院校",
    clearSelection: "清除选择",
    noResults: "未找到院校",
  },

  // 课程
  courses: {
    title: "课程",
    subtitle: "真实学生，真实点评，聪明选课从这里开始",
    name: "课程名称",
    code: "课程代码",
    credits: "学分",
    semester: "学期",
    year: "年份",
    instructor: "授课老师",
    department: "学院",
    description: "课程简介",
    prerequisites: "先修要求",
    difficulty: "难度",
    workload: "工作量",
    rating: "评分",
    reviews: "点评",
    enrollment: "选课人数",
    capacity: "容量",
    schedule: "上课时间",
    location: "地点",
    textbook: "教材",
    syllabus: "教学大纲",
    searchPlaceholder: "搜索课程…",
    filterByDepartment: "按学院筛选",
    filterByCredits: "按学分筛选",
    filterByDifficulty: "按难度筛选",
    filterBySemester: "按学期筛选",
    easy: "简单",
    medium: "一般",
    hard: "较难",
    veryHard: "非常难",
    beginner: "入门",
    intermediate: "进阶",
    advanced: "高级",
    expert: "专家",
    spring: "春季",
    summer: "夏季",
    fall: "秋季",
    winter: "冬季",
    viewDetails: "查看详情",
    enroll: "加入课程",
    unenroll: "退出课程",
    addToWishlist: "加入心愿单",
    removeFromWishlist: "移出心愿单",
    shareLink: "分享链接",
    reportIssue: "反馈问题",
  },

  // 新增课程
  addCourse: {
    title: "新增课程",
    subtitle: "没找到这门课？自己添加并写下第一条点评吧！",
    form: {
      university: "院校",
      universityPlaceholder: "请选择院校",
      courseName: "课程名称",
      courseNamePlaceholder: "如：计算机基础",
      courseCode: "课程代码",
      courseCodePlaceholder: "如：CS101、MATH200",
      department: "学院（可选）",
      departmentPlaceholder: "如：计算机学院、数学系",
      credits: "学分（可选）",
      level: "层次（可选）",
      levelPlaceholder: "请选择层次",
      levelBachelor: "本科",
      levelMaster: "硕士",
      levelPhD: "博士",
    },
    actions: {
      cancel: "取消",
      submit: "添加课程并写点评",
    },
    messages: {
      selectUniversity: "请先选择院校",
      loadUniversitiesFailed: "院校数据加载失败",
      addSuccess: "课程添加成功！快去写下第一条点评吧。",
      addFailed: "课程添加失败",
      duplicateCourse: "该课程已存在！正在为你跳转到已有课程…",
    },
  },

  // 点评
  reviews: {
    title: "点评",
    subtitle: "这门课值不值得上？老师好不好？工作量大不大？这里都有答案。",
    write: "写点评",
    noCourseReviews: "该课程暂无点评",
    beFirstToReview: "抢先写下第一条点评",
    writeReview: "写点评",
    editReview: "编辑点评",
    deleteReview: "删除点评",
    rating: "评分",
    comment: "评论",
    helpful: "有用",
    notHelpful: "没用",
    report: "举报",
    anonymous: "匿名",
    verified: "已认证",
    recent: "最新",
    popular: "热门",
    highest: "评分最高",
    lowest: "评分最低",
    filterByRating: "按评分筛选",
    filterByDate: "按时间筛选",
    sortBy: "排序",
    newest: "最新",
    oldest: "最早",
    mostHelpful: "最有用",
    leastHelpful: "最没用",
    searchReviews: "搜索点评…",
    reviewCount: "条点评",
    averageRating: "平均评分",
    ratingDistribution: "评分分布",
    wouldRecommend: "愿意推荐",
    wouldNotRecommend: "不推荐",
    reviewGuidelines: "点评规范",
    characterLimit: "字数限制",
    remainingCharacters: "剩余字符",
    submissionSuccess: "点评提交成功",
    submissionFailed: "点评提交失败",
    updateSuccess: "点评更新成功",
    updateFailed: "点评更新失败",
    deleteSuccess: "点评删除成功",
    deleteFailed: "点评删除失败",
    confirmDelete: "确定要删除这条点评吗？",
    wasHelpful: "这条点评有帮助吗？",
    loginToVote: "登录后才能投票",
    professorStyle: "老师风格",
    selectProfessorTags: "选择最符合这位老师的标签",
    professorTags: "老师标签",
    professorTagsDescription: "请根据你的体验选择最贴切的标签",
    selectedTags: "已选标签（{count}）",
    reply: "回复",
    replies: "回复",
    repliesCount: "{count} 条回复",
    replyPlaceholder: "写下你的回复…",
    submitReply: "发送回复",
    replySubmitted: "回复发送成功",
    replyFailed: "回复发送失败",
    replyUpdated: "回复更新成功",
    replyUpdateFailed: "回复更新失败",
    pleaseEnterReply: "请先输入回复内容",
    showMoreReplies: "展开更多回复",
    deleteReply: "删除回复",
    confirmDeleteReply: "确定要删除这条回复吗？",
    sendMessage: "发私信",
    postAnonymously: "匿名发布",
    anonymousTooltip: "你的昵称将对其他用户隐藏",
    thankYou: "感谢你的反馈！",
    thankYouPositive: "感谢你的点赞！",
    voteCanceled: "已撤回投票",
    voteFailed: "投票失败",
    cannotVoteOwnReview: "不能给自己的点评投票",
    youFoundThisReview: "你觉得这条点评",
    voteHelpful: "有帮助",
    voteNotHelpful: "没帮助",
    deletedTitle: "该点评已被作者删除",
    deletedSubtitle: "以下回复仍会保留展示",
    accessControl: {
      limitedCardTitle: "访问受限",
      limitReachedCardTitle: "已达到查看上限",
      limitAlertTitle: "当前为限免模式",
      limitReachedAlertTitle: "已用完免费次数",
      limitAlertDescription:
        "未贡献点评时，你最多可查看 {limit} 条点评。剩余免费次数：{remaining}。",
      limitReachedDescription:
        "你已经读完 {limit} 条免费点评，写一条点评即可解锁更多内容。",
      unlockTitle: "🚀 解锁完整访问",
      unlockWriteReviewTitle: "写一条点评",
      unlockWriteReviewDescription: "分享课程体验，即可再获 30 天无限访问。",
      writeReviewCta: "去写点评",
      statusTitle: "当前进度",
      reviewsViewedLabel: "已查看点评",
      reviewsWrittenLabel: "已发表点评",
      remainingReviewsLabel: "剩余免费点评",
      premiumCardTitle: "高级权限已激活",
      premiumAlertTitle: "无限访问模式",
      premiumAlertDescription: "你现在可以无限制查看所有点评。",
      premiumValidUntil: "有效期至",
      premiumReviewedThisMonth: "本月已写点评",
      premiumTotalReviews: "累计点评数",
      encourageCardTitle: "快来讲讲你的故事",
      encourageDescription: "把你的上课体验告诉后来人！",
      encourageCta: "写下第一条点评",
    },
    progressiveLoading: {
      showMore: "加载更多点评",
      showMoreCount: "({current}/{total})",
      loadHint: "一次展示 1 条点评",
      limitReached: "已达到查看上限",
      youViewed: "你已查看 <strong>{count}</strong> 条点评（上限 {limit}）",
      unlockRemaining: "还有 <strong>{count}</strong> 条点评待解锁",
      unlockWriteTitle: "写点评解锁剩余内容",
      unlockWriteDesc: "写一条课程点评即可延长 30 天无限访问",
      writeNowBtn: "立刻写点评",
      freeBadge: "免费 · 可叠加",
      or: "或",
      unlockInviteTitle: "邀请好友也能解锁",
      unlockInviteDesc: "邀请好友注册并写点评，你们双方都能获得 1 年会籍",
      getInviteCodeBtn: "获取邀请码",
      stackableInfo: "两种方式可以叠加，时间自动累计",
    },
  },

  // 推荐
  recommendations: {
    title: "推荐",
    subtitle: "加入数千名同学的行列，轻松做出更聪明的选课决策",
    smartRecommendations: "智能推荐",
    aiPoweredSubtitle: "基于 AI 的个性化课程推荐",
    recommendationSettings: "推荐设置",
    refreshAll: "全部刷新",
    recommendationEngine: "推荐引擎",
    engineDescription: "AI 模型基于 {count} 次互动训练 · 最近更新：{date}",
    accuracy: "准确度",
    confidence: "信心指数",
    personalizedForYou: "专属推荐",
    courses: "门课程",
    relevance: "匹配度",
    rating: "评分",
    difficulty: "难度",
    sortByRelevance: "按匹配度排序",
    sortByRating: "按评分排序",
    sortByDifficulty: "按难度排序",
    signInForPersonalized: "登录即可看到专属推荐",
    signInDescription: "基于你的兴趣、背景与学习目标的智能推荐。",
    signIn: "去登录",
    createAccount: "注册账号",
    or: "或",
    browsePopular: "看看热门课程",
    benefits: {
      smartAI: "AI 智能匹配你的口味",
      trackProgress: "追踪课程偏好与学习进度",
      discoverCourses: "发现适合你水平的课程",
    },
    trendingNow: "近期最火",
    growth: "热度",
    match: "匹配",
    topRated: "高分好课",
    reviews: "条点评",
    becauseYouViewed: "因为你看过",
    basedOnHistory: "基于你的浏览历史",
    youViewed: "你曾看过",
    similarCourses: "类似课程",
    viewDetails: "查看详情",
    excellentMatch: "高度匹配",
    greatMatch: "非常合适",
    goodMatch: "较为匹配",
    settings: {
      title: "推荐设置",
      focus: "推荐侧重点",
      balanced: "综合推荐",
      popular: "热门课程",
      challenging: "挑战型课程",
      easy: "轻松型课程",
      difficultyPreference: "难度偏好",
      difficultyLevels: {
        easy: "简单",
        medium: "适中",
        hard: "困难",
      },
      subjectInterests: "兴趣领域",
      subjects: {
        computerScience: "计算机",
        mathematics: "数学",
        engineering: "工程",
        business: "商科",
        languages: "语言",
      },
      cancel: "取消",
      save: "保存设置",
      saved: "设置已保存",
    },
    noPersonalizedRecommendations: "暂时没有个性化推荐",
    explorePopularCourses: "去看看热门课程",
    allRecommendationsRefreshed: "推荐列表已刷新",
    recommendationDismissed: "已移除该推荐",
    addedToWishlist: "已添加到心愿单！",
    forYou: "为你推荐",
    trending: "热门推荐",
    popular: "全站热门",
    similar: "相似课程",
    basedOnRatings: "基于你的评分",
    basedOnFavorites: "基于你的收藏",
    recommendedCourses: "推荐课程",
    recommendedUniversities: "推荐院校",
    whyRecommended: "推荐理由",
    because: "因为你",
    viewed: "浏览过",
    rated: "评价过",
    favorited: "收藏过",
    enrolled: "选修",
    searched: "搜索过",
    similar_users: "兴趣相近的同学也喜欢",
    matching_criteria: "符合你的筛选条件",
    high_rating: "评分表现优秀",
    popular_choice: "近期大家都在看",
    refreshRecommendations: "刷新推荐",
    noRecommendations: "暂无推荐内容",
    improveRecommendations: "优化推荐",
    feedback: "反馈",
    feedbackHelpful: "有用",
    feedbackNotHelpful: "没用",
    irrelevant: "不相关",
    alreadyKnown: "早就知道",
    notInterested: "没兴趣",
    thankYou: "感谢你的反馈！",
    personal: {
      title: "个人化推荐",
      description: "基于你的喜好与评分",
    },
  },

  // 统计
  stats: {
    title: "数据统计",
    overview: "概览",
    analytics: "分析",
    reports: "报告",
    dashboard: "仪表盘",
    totalUsers: "总用户",
    totalCourses: "课程数量",
    totalUniversities: "院校数量",
    totalReviews: "点评数量",
    activeUsers: "活跃用户",
    newRegistrations: "新增注册",
    courseEnrollments: "选课次数",
    averageRating: "平均评分",
    topRatedCourses: "高分课程",
    topRatedUniversities: "高分院校",
    mostPopularCourses: "热门课程",
    mostPopularUniversities: "热门院校",
    userActivity: "用户动态",
    searchTrends: "搜索趋势",
    geographicDistribution: "地区分布",
    timeRange: "时间范围",
    last7Days: "最近 7 天",
    last30Days: "最近 30 天",
    last3Months: "最近 3 个月",
    lastYear: "最近一年",
    allTime: "全部",
    exportData: "导出数据",
    generateReport: "生成报告",
    downloadReport: "下载报告",
    viewFullReport: "查看完整报告",
    noData: "暂无数据",
    loadingData: "数据加载中…",
    refreshData: "刷新数据",
  },

  // 错误提示
  errors: {
    general: "发生了一个错误",
    network: "网络异常",
    timeout: "请求超时",
    unauthorized: "未授权访问",
    forbidden: "没有访问权限",
    notFound: "页面不存在",
    serverError: "服务器错误",
    validationError: "校验失败",
    unknownError: "未知错误",
    tryAgain: "请再试一次",
    contactSupport: "联系支持",
    goBack: "返回上一页",
    reload: "重新加载",
    defaultTitle: "系统发生异常",
    defaultMessage: "系统出现意外错误，请稍后再试",
    networkTitle: "网络连接问题",
    networkMessage: "无法连接到服务器，请检查网络后重试",
    notFoundTitle: "页面未找到",
    notFoundMessage: "资源不存在，可能被移动或删除",
    permissionTitle: "权限不足",
    permissionMessage: "你没有访问该资源的权限，请重新登录",
  },

  // 表单校验
  validation: {
    required: "该字段不能为空",
    email: "请输入合法的邮箱地址",
    password: "密码至少 6 个字符",
    confirmPassword: "两次输入的密码不一致",
    username: "用户名需为 3-20 个字符",
    phoneNumber: "请输入合法手机号",
    url: "请输入合法的链接",
    number: "请输入数字",
    integer: "请输入整数",
    decimal: "请输入小数",
    date: "请输入合法日期",
    time: "请输入合法时间",
    minLength: "最少 {min} 个字符",
    maxLength: "最多 {max} 个字符",
    minValue: "数值需 ≥ {min}",
    maxValue: "数值需 ≤ {max}",
    pattern: "格式不正确",
    unique: "该值已存在",
    fileSize: "文件大小需小于 {size}",
    fileType: "文件类型不支持",
    imageFormat: "图片格式不支持",
  },

  // 分页
  pagination: {
    page: "第",
    of: "页 共",
    pages: "页",
    items: "条",
    showing: "正在显示",
    to: "到",
    total: "共",
    first: "第一页",
    last: "最后一页",
    previous: "上一页",
    next: "下一页",
    goTo: "跳转到",
    itemsPerPage: "每页条数",
    showAll: "显示全部",
  },

  // 日期时间
  date: {
    today: "今天",
    yesterday: "昨天",
    tomorrow: "明天",
    thisWeek: "本周",
    lastWeek: "上周",
    nextWeek: "下周",
    thisMonth: "本月",
    lastMonth: "上月",
    nextMonth: "下月",
    thisYear: "今年",
    lastYear: "去年",
    nextYear: "明年",
    now: "现在",
    soon: "很快",
    later: "稍后",
    never: "暂无",
    always: "一直",
    recently: "刚刚",
    ago: "前",
    in: "后",
    seconds: "秒",
    minutes: "分钟",
    hours: "小时",
    days: "天",
    weeks: "周",
    months: "个月",
    years: "年",
    daysAgo: "{count} 天前",
    weeksAgo: "{count} 周前",
    monthsAgo: "{count} 个月前",
    semester: {
      WS: "冬季学期",
      SS: "夏季学期",
    },
  },

  // 主题
  theme: {
    switchToLight: "切换到亮色模式",
    switchToDark: "切换到暗色模式",
    lightMode: "亮色模式",
    darkMode: "暗色模式",
  },

  // 关于我们
  about: {
    title: "关于 KursKompass",
    subtitle: "用社区的力量，帮学生做出更靠谱的选课决定",
    story: {
      title: "我们的故事",
      paragraph1:
        "KursKompass 源于一个简单却重要的念头：在做出选课决定前，每位学生都值得拥有透明、真实的信息。",
      paragraph2:
        "作为学生，我们也曾盲选课程，结果发现老师风格、作业强度与预期不符。我们意识到，只要把同学们的真实体验汇聚起来，就能避免更多人踩坑。",
      paragraph3:
        "如今，KursKompass 服务着德国各高校的学生，帮助他们挑到合适课程、打造更理想的学习路径。平台也会持续结合社区反馈不断迭代。",
    },
    mission: {
      title: "我们的使命",
      transparency: {
        title: "透明优先",
        description: "让每位学生在选课前先看到真实的老师与课程体验。",
      },
      community: {
        title: "由社区驱动",
        description: "平台依靠学生的分享不断成长，形成互助共赢的生态。",
      },
      improvement: {
        title: "持续改进",
        description: "我们会基于用户需求不断优化产品体验。",
      },
    },
    contact: {
      title: "联系我们",
      description: "有任何想法或建议？告诉我们，让平台更契合学生的真实需求。",
      email: {
        title: "发送邮件",
      },
      feedback: {
        title: "提交反馈",
        description: "分享你的想法或问题，帮助我们提升平台。",
      },
      sendFeedback: "发送反馈",
    },
    feedback: {
      title: "意见反馈",
      type: "反馈类型",
      subject: "主题",
      message: "内容",
      email: "邮箱（可选）",
      subjectPlaceholder: "简要描述你的反馈内容",
      messagePlaceholder: "详细说明你的建议、感受或遇到的问题…",
      emailPlaceholder: "your.email{'@'}example.com",
      types: {
        placeholder: "选择反馈类型",
        suggestion: "功能建议",
        bug: "问题反馈",
        feature: "功能需求",
        general: "其他反馈",
      },
      submitted: "感谢你的反馈，我们会认真参考。",
      successMessage: "感谢你的反馈！我们会尽快查看。",
      errorMessage: "提交失败，请稍后再试。",
    },
  },

  // 页脚
  footer: {
    quickLinks: "快速入口",
    features: "平台功能",
    aboutContact: "关于与联系",
    aboutUs: "关于我们",
    contact: "联系我们",
    sendFeedback: "提交反馈",
    privacy: "隐私政策",
    professorProfiles: "老师画像",
    advancedSearch: "高级搜索",
    allRightsReserved: "版权所有。",
  },

  // 收藏
  bookmarks: {
    bookmark: "收藏",
    bookmarked: "已收藏",
    addToBookmarks: "添加收藏",
    addedSuccess: "收藏成功！",
    removedSuccess: "已移除收藏",
    alreadyBookmarked: "你已经收藏过了",
    error: "更新收藏状态失败",
    notes: "笔记",
    notesPlaceholder: "记录你对这门课的私密备注…",
    editNotes: "编辑笔记",
    notesUpdated: "笔记更新成功",
    notesError: "笔记更新失败",
    removeBookmark: "取消收藏",
    contextMenuTitle: "收藏选项",
    contextMenuMessage: "你想对这条收藏做什么？",
    myBookmarks: "我的收藏",
    noBookmarks: "暂时还没有收藏",
    searchBookmarks: "搜索收藏…",
    trendingBookmarks: "热门收藏",
    viewAll: "查看全部收藏",
    stats: {
      total: "收藏总数",
      recent: "最近收藏",
      categories: "热门类别",
    },
  },

  // 关注
  follows: {
    follow: "关注",
    following: "已关注",
    mutual: "互相关注",
    unfollow: "取消关注",
    followedSuccess: "你已关注 {username}！",
    unfollowedSuccess: "你已取消关注 {username}",
    alreadyFollowing: "你已经关注了该用户",
    alreadyUnfollowed: "你已取消关注",
    cannotFollowSelf: "不能关注自己",
    error: "更新关注状态失败",
    user: "用户",
    followers: "粉丝",
    followersCount: "{count} 位粉丝",
    followingCount: "关注 {count} 人",
    mutualFollows: "互关",
    recentFollowers: "最新粉丝",
    noFollowers: "还没有粉丝",
    noFollowing: "还没有关注任何人",
    stats: {
      following: "关注中",
      followers: "粉丝",
      mutual: "互关",
    },
  },

  // 私信
  messagesPage: {
    title: "消息",
    tabs: {
      inbox: "收件箱",
      sent: "已发送",
    },
    empty: {
      noMessages: "暂无消息",
      noSentMessages: "暂无发送记录",
    },
    actions: {
      markAsRead: "标为已读",
      delete: "删除",
      compose: "写私信",
      send: "发送",
      cancel: "取消",
      close: "关闭",
      reply: "回复",
    },
    form: {
      receiver: "收件人",
      receiverPlaceholder: "输入用户 ID",
      sendingTo: "发给：",
      subject: "主题",
      subjectPlaceholder: "填写消息主题",
      message: "内容",
      messagePlaceholder: "输入你的消息",
      messageSimplePlaceholder: "在此输入消息…",
    },
    dialog: {
      composeTitle: "写消息",
      composeToUser: "发送给 {username}",
      from: "发件人：",
      to: "收件人：",
      date: "日期：",
      read: "已读：",
      sentAt: "发送时间：",
      content: "内容：",
    },
    confirm: {
      deleteTitle: "确认删除",
      deleteMessage: "确定要删除这条消息吗？",
      deleteButton: "删除",
      cancelButton: "取消",
    },
    messages: {
      loadFailed: "消息加载失败",
      sendSuccess: "发送成功",
      sendFailed: "发送失败",
      markReadFailed: "标记已读失败",
      markReadSuccess: "已标记为已读",
      deleteSuccess: "删除成功",
      deleteFailed: "删除失败",
    },
  },

  // 邀请系统
  invitation: {
    title: "邀请好友",
    subtitle: "邀请好友注册并写点评，双方即可各得 1 年高级权限！",
    myCode: "我的邀请码",
    yourCode: "你的专属邀请码",
    myCodeSubtitle: "邀请码永久有效，想邀请多少好友都没问题！",
    totalUses: "使用次数",
    completedReviews: "完成点评",
    usageHistory: "使用记录",
    reviewStatus: "点评状态",
    reviewed: "已点评",
    pending: "待点评",
    reviewedAt: "点评时间",
    premiumStatus: "高级状态",
    granted: "已授予",
    generateCode: "生成邀请码",
    generating: "生成中…",
    myInvitations: "我的邀请码列表",
    code: "邀请码",
    statusLabel: "状态",
    createdAt: "创建时间",
    usedAt: "使用时间",
    invitee: "受邀用户",
    actions: "操作",
    copyCode: "复制邀请码",
    share: "分享",
    shareCode: "分享邀请码",
    copied: "复制成功！",
    generated: "邀请码生成成功！",
    error: "邀请码生成失败",
    noInvitations: "暂时还没有邀请码",
    codeInfo: "此邀请码永久有效，可无限制分享给好友。",
    viewDetails: "查看详情",
    statusTypes: {
      pending: "待使用",
      used: "已使用",
      completed: "已完成（权限已发放）",
    },
    shareMessage: "来 KursKompass 看真实课程点评，使用我的邀请码：{code}\n朋友写下第一条点评，我们俩都能获得 1 年高级使用权！",
    howItWorks: {
      title: "怎么玩",
      step1: "邀请码随时可用",
      step2: "分享给任意好友",
      step3: "他们注册并写第一条点评",
      step4: "你们双方各得 1 年高级权限",
    },
  },

  // 高级权限记录
  premium: {
    title: "高级权限记录",
    subtitle: "查看高级权限的获取来源与到期时间",
    currentStatus: "当前状态",
    active: "高级权限激活中",
    expired: "已过期",
    expiresOn: "到期时间",
    expiredOn: "过期时间",
    history: "历史记录",
    grantedAt: "发放时间",
    duration: "时长",
    source: "来源",
    noHistory: "暂无高级权限记录",
    noPremiumAccess: "尚未获得高级权限",
    noPremiumDescription: "写点评或邀请好友即可解锁更多特权！",
    unlockFeatures: "解锁无广告、优先支持等专属功能",
    writeReview: "写点评（+30 天）",
    inviteFriend: "邀请好友（+1 年）",
    stackingInfo: "时长可叠加，写点评 + 邀好友就能长期保持高级权限。",
    sources: {
      REVIEW: "撰写点评",
      REFERRAL_INVITER: "好友受邀并写点评",
      REFERRAL_INVITEE: "通过邀请码加入",
    },
    durations: {
      month: "30 天",
      year: "1 年",
    },
  },

  // 统计仪表盘
  statsDashboard: {
    title: "分析仪表盘",
    subtitle: "全面洞察平台数据",
    refresh: "刷新",
    dateRange: {
      to: "至",
      startPlaceholder: "开始日期",
      endPlaceholder: "结束日期",
    },
    metrics: {
      totalCourses: "课程总数",
      totalReviews: "点评总数",
      activeUsers: "活跃用户",
      avgRating: "平均评分",
    },
    charts: {
      reviewsOverTime: "点评数量走势",
      ratingDistribution: "评分分布",
      universityPerformance: "院校表现对比",
      topRatedCourses: "高分课程榜",
    },
    timeframes: {
      last7Days: "最近 7 天",
      last30Days: "最近 30 天",
      last3Months: "最近 3 个月",
      lastYear: "最近 1 年",
    },
    universityMetrics: {
      avgRating: "平均分",
      totalReviews: "点评总数",
      totalCourses: "课程总数",
    },
    activity: {
      title: "最新动态",
      filters: {
        all: "全部",
        reviews: "点评",
        courses: "课程",
        users: "用户",
      },
      types: {
        courseAdded: "新增课程",
        highRating: "获得高分",
        newUsers: "新用户注册",
      },
      timeAgo: {
        minutesAgo: "{count} 分钟前",
        hoursAgo: "{count} 小时前",
        daysAgo: "{count} 天前",
      },
    },
    messages: {
      refreshSuccess: "数据刷新成功",
      refreshError: "数据刷新失败",
    },
  },

  // 我的点评
  reviewsPage: {
    title: "我的点评",
    subtitle: "管理你写过的课程点评，看看自己对社区的贡献",
    stats: {
      totalReviews: "点评总数",
      averageRating: "平均评分",
      semesters: "涉及学期",
    },
    card: {
      title: "我的点评",
      searchPlaceholder: "搜索我的点评…",
    },
    filters: {
      rating: "按评分筛选",
      semester: "按学期筛选",
      sortBy: "排序方式",
      clearFilters: "清除筛选",
    },
    rating: {
      stars5: "5 星",
      stars4: "4 星",
      stars3: "3 星",
      stars2: "2 星",
      stars1: "1 星",
    },
    semester: {
      winter2024: "2024 冬季",
      summer2024: "2024 夏季",
      winter2023: "2023 冬季",
      summer2023: "2023 夏季",
      winterFull2024: "2024 冬季学期",
      summerFull2024: "2024 夏季学期",
      winterFull2023: "2023 冬季学期",
      summerFull2023: "2023 夏季学期",
    },
    sort: {
      newest: "最新优先",
      oldest: "最早优先",
      highest: "评分最高",
      lowest: "评分最低",
    },
    empty: {
      title: "暂时还没有点评",
      action: "去写第一条课程点评",
    },
    actions: {
      edit: "编辑",
      delete: "删除",
    },
    editDialog: {
      title: "编辑点评",
      course: "课程",
      rating: "评分",
      semester: "学期",
      semesterPlaceholder: "选择学期",
      comment: "评论",
      commentPlaceholder: "更新你的点评…",
      cancel: "取消",
      update: "更新点评",
    },
    ratingTexts: {
      terrible: "糟糕",
      bad: "不佳",
      average: "一般",
      good: "不错",
      excellent: "超赞",
    },
    messages: {
      updateSuccess: "点评更新成功",
      updateError: "点评更新失败",
      deleteConfirmTitle: "删除点评",
      deleteConfirmMessage: "确定删除这条点评吗？",
      deleteSuccess: "点评删除成功",
      deleteError: "点评删除失败",
    },
  },

  // 邮箱验证
  emailVerification: {
    title: "邮箱验证",
    loading: "正在验证你的邮箱…",
    success: {
      title: "邮箱验证成功！",
      message: "欢迎加入 KursKompass，现在可以登录使用所有功能了。",
      action: "前往登录",
    },
    error: {
      title: "验证失败",
      action: "重新注册",
    },
    initial: {
      title: "邮箱验证",
      message: "请查收邮箱并点击验证链接以激活账号。",
    },
    resend: {
      prompt: "没收到邮件？",
      placeholder: "输入邮箱地址",
      button: "重新发送",
      buttonSending: "发送中…",
      buttonResend: "重新发送验证邮件",
      success: "验证邮件已重新发送，请检查邮箱。",
      error: "发送失败，请稍后再试。",
      emailRequired: "请输入邮箱地址",
    },
  },

  // 个人主页
  profilePage: {
    actions: {
      editProfile: "编辑资料",
      changePassword: "修改密码",
    },
    tabs: {
      info: "资料",
      reviews: "我的点评",
      invitations: "邀请码",
      premium: "高级记录",
    },
    premiumStatus: {
      title: "高级权限状态",
      activeTitle: "⭐ 高级权限已激活",
      inactiveTitle: "解锁高级权限",
      activeMessage: "你正在享受全部高级功能。",
      inactiveMessage: "写点评或邀请好友即可获得高级权限。",
      expiresOn: "到期时间",
      extendTitle: "延长高级时长",
      extendMessage: "再写点评或邀请好友即可延长权限时间。",
      writeReviewButton: "写点评（+30 天）",
      inviteFriendButton: "邀请好友（+1 年）",
      active: "高级权限生效中",
      validUntil: "有效期至：",
      unlimited: "✓ 点评访问无限制",
    },
    personalInfo: {
      title: "个人信息",
      firstName: "名",
      lastName: "姓",
      university: "院校",
      major: "专业",
      graduationYear: "毕业年份",
      username: "用户名",
      email: "邮箱",
      totalReviews: "点评数量",
      notProvided: "暂无填写",
    },
    bio: {
      title: "个人简介",
    },
    reviews: {
      title: "我的课程点评",
      stats: {
        total: "点评总数",
        avgRating: "平均评分",
      },
      empty: "你还没有写过点评",
      sortBy: "排序方式",
      sortOptions: {
        newest: "最新优先",
        oldest: "最早优先",
        highest: "评分最高",
        lowest: "评分最低",
      },
      actions: {
        edit: "编辑",
        delete: "删除",
      },
      deleteConfirm: {
        title: "删除点评",
        message: "确定要删除这条点评吗？",
      },
    },
    editDialog: {
      title: "编辑个人资料",
      sections: {
        personal: "个人信息",
        academic: "学业信息",
        contact: "联系信息",
        bio: "个人简介",
      },
      fields: {
        firstName: "名",
        lastName: "姓",
        university: "院校",
        major: "专业",
        graduationYear: "毕业年份",
        email: "邮箱地址",
        bio: "个人简介",
      },
      placeholders: {
        firstName: "填写你的名字",
        lastName: "填写你的姓氏",
        university: "选择院校",
        major: "如：计算机科学",
        graduationYear: "如：2025",
        email: "your.email{'@'}example.com",
        bio: "写点关于自己的信息…（可选）",
      },
      current: "当前：",
      displayNamePreference: "展示方式",
      displayName: {
        realname: "实名",
        username: "用户名",
        anonymous: "匿名",
        anonymousDesc: "对外显示为匿名用户",
      },
      cancel: "取消",
      save: "保存",
      saveChanges: "保存更改",
      messages: {
        updateSuccess: "资料更新成功",
        updateError: "资料更新失败",
      },
    },
    passwordDialog: {
      title: "修改密码",
      currentPassword: "当前密码",
      newPassword: "新密码",
      confirmPassword: "确认新密码",
      cancel: "取消",
      change: "修改密码",
      messages: {
        success: "密码修改成功",
        error: "密码修改失败",
      },
    },
    validation: {
      emailRequired: "请输入合法邮箱",
      yearRequired: "请输入合法年份",
      currentPasswordRequired: "请输入当前密码",
      newPasswordRequired: "请输入新密码",
      confirmPasswordRequired: "请再次输入密码",
      passwordMismatch: "两次密码不一致",
    },
  },

  // 新增院校
  addUniversity: {
    title: "新增院校",
    subtitle: "把新的德国高校添加到平台",
    fields: {
      name: "院校名称",
      shortName: "简称",
      city: "城市",
      state: "州/邦",
      type: "类型",
      established: "创办年份",
      website: "官网",
      description: "简介",
    },
    placeholders: {
      name: "如：Technische Universität München",
      shortName: "如：TUM、LMU",
      city: "如：München",
      state: "如：Bayern",
      type: "选择类型",
      website: "https://www.university.de",
      description: "简要介绍该院校的特点与优势",
    },
    types: {
      full: "综合大学",
      technical: "理工大学",
      applied: "应用技术大学",
      art: "艺术学院",
      music: "音乐学院",
      sport: "体育学院",
    },
    actions: {
      cancel: "取消",
      submit: "新增院校",
    },
    validation: {
      nameRequired: "请输入院校名称",
      nameLength: "长度需在 2-200 个字符之间",
      shortNameRequired: "请输入院校简称",
      shortNameLength: "长度需在 2-50 个字符之间",
      cityRequired: "请输入城市",
      cityLength: "长度需在 2-50 个字符之间",
      stateRequired: "请输入州/邦",
      stateLength: "长度需在 2-50 个字符之间",
      typeRequired: "请选择类型",
      establishedRequired: "请输入创办年份",
      websiteInvalid: "请输入合法的链接",
      descriptionRequired: "请输入院校简介",
      descriptionLength: "长度需在 10-1000 个字符之间",
    },
    messages: {
      success: "院校添加成功！",
      error: "院校添加失败",
    },
  },

  // 监控仪表盘
  monitoring: {
    title: "搜索服务监控面板",
    checking: "检测中…",
    refresh: "刷新数据",
    refreshing: "刷新中…",
    stats: {
      totalSearches: "总搜索次数",
      avgResponseTime: "平均响应时间",
      maxResponseTime: "最大响应时间",
      systemStatus: "系统状态",
    },
    popularSearches: {
      title: "TOP10 热门搜索词",
      loading: "加载中…",
      times: "次",
    },
    errors: {
      loadFailed: "热门搜索加载失败",
      refreshFailed: "刷新失败",
    },
  },

  // 学生认证
  verification: {
    title: "学生认证",
    verifyCode: "验证验证码",
    instructions: "使用你的高校邮箱验证学生身份。",
    universityLabel: "院校",
    selectUniversity: "选择院校",
    universityRequired: "请先选择院校",
    selectUniversityFirst: "请先选择院校",
    loadingDomains: "正在加载可用域名…",
    emailLabel: "高校邮箱",
    emailCalloutTitle: "高校邮箱",
    emailCalloutSubtitle: "仅支持平台收录的邮箱域名。",
    emailPlaceholder: "your.name{'@'}university.edu",
    emailRequired: "请输入高校邮箱",
    emailInvalid: "邮箱格式不正确",
    validDomains: "支持的域名",
    validDomainHint: "该邮箱域名在支持列表中：{domain}",
    invalidDomainHint: "暂未收录该域名，可反馈给管理员。",
    unknownDomainHint: "无法识别该域名，请再次确认邮箱。",
    sendCode: "发送验证码",
    codeLabel: "验证码",
    codePlaceholder: "六位数字",
    codeRequired: "请输入验证码",
    codeLength: "验证码需为 6 位数字",
    verify: "立即验证",
    resendCode: "重新发送",
    resendIn: "{seconds} 秒后可重发",
    codeSent: "验证码已发送到 {email}",
    successTitle: "验证完成",
    successMessage: "学生身份验证成功。",
    codeSentSuccess: "验证码发送成功",
    verifySuccess: "验证成功",
    resendSuccess: "验证码已重新发送",
    loadUniversitiesError: "院校列表加载失败",
    sendCodeError: "验证码发送失败",
    verifyError: "验证失败",
    resendError: "验证码重发失败",
    verifiedStudent: "已认证学生",
    verifyStudentStatus: "验证学生身份",
  },

  // 用户预览卡片
  userPreview: {
    reviews: "点评",
    followers: "粉丝",
    likes: "获赞",
    message: "私信",
    viewProfile: "查看资料",
    loadFailed: "用户信息加载失败",
  },

  // 用户主页
  userProfile: {
    overview: "概览",
    reviews: "点评",
    activity: "动态",
    bio: "简介",
    major: "专业",
    graduationYear: "毕业年份",
    joinedDate: "加入时间",
    followersCount: "粉丝",
    followingCount: "关注",
    reviewsCount: "点评数",
    totalUpvotes: "获赞总数",
    likes: "点赞",
    noBio: "该用户尚未填写简介。",
    noBioOwn: "你还没有写简介，点击“添加简介”告诉大家你是谁吧！",
    noReviews: "暂无点评",
    loadError: "用户资料加载失败",
    courseName: "课程",
    semester: "学期",
    viewCourse: "查看课程",
    editBio: "编辑简介",
    addBio: "添加简介",
    bioPlaceholder: "写点自己的故事…",
    bioUpdateSuccess: "简介更新成功",
    bioUpdateFailed: "简介更新失败",
    verifiedStudent: "认证学生",
  },

  // 点评筛选器
  reviewFilter: {
    title: "筛选与排序点评",
    clearAll: "清除全部",
    rating: "评分",
    anyRating: "任意评分",
    star: "星 | 星",
    semester: "学期",
    anySemester: "任意学期",
    sortBy: "排序方式",
    mostRecent: "最新",
    highestRating: "评分最高",
    lowestRating: "评分最低",
    mostHelpful: "最有帮助",
    searchReviews: "搜索点评",
    searchPlaceholder: "在点评内容中搜索…",
    reviewLength: "点评长度",
    anyLength: "任意长度",
    shortReviews: "简短点评（< 100 字符）",
    mediumReviews: "中等点评（100-300 字符）",
    longReviews: "长篇点评（> 300 字符）",
    verifiedStudents: "认证学生",
    onlyVerified: "仅认证用户",
    allReviews: "全部点评",
    hide: "隐藏",
    show: "显示",
    advancedFilters: "高级筛选",
    activeFilters: "已启用筛选",
    verifiedStudentsOnly: "仅认证学生",
  },

  // 课程页面
  coursesPage: {
    title: "课程探索",
    subtitle: "通过我们的高级搜索和筛选系统发现课程",
    universityTip: "💡 在下方搜索筛选中选择你的院校，查看个性化课程推荐",
    addCourseHint: "找不到你的课程？添加它并分享你的第一条点评！",
    addCourse: "添加课程",
    coursesFound: "找到 {count} 门课程",
    showingResults: "展示你的搜索和筛选结果",
    grid: "网格",
    list: "列表",
    noCourses: "未找到课程",
    noCoursesDescription: "没有找到符合条件的课程",
    noCoursesSubtitle: "尝试调整搜索筛选条件，或查看上方提示添加新课程！",
    clearFilters: "清除筛选",
    courseCode: "课程代码",
    viewDetails: "查看详情",
    viewReviews: "查看点评",
  },

  // 点评统计
  reviewStats: {
    title: "点评统计",
    reviewsCount: "{count} 条点评",
    ratingDistribution: "评分分布",
    averageRating: "平均评分",
    totalReviews: "总点评数",
    recommend: "推荐",
    overallRating: "综合评分",
    courseCharacteristics: "课程特征",
    difficulty: "难度",
    workload: "工作量",
    teaching: "教学质量",
    courseRatingQuality: "课程评分质量",
    difficultyLabels: {
      veryEasy: "非常简单",
      easy: "简单",
      moderate: "适中",
      challenging: "较难",
      veryChallenging: "非常难",
    },
    workloadLabels: {
      veryLight: "很轻松",
      light: "轻松",
      moderate: "适中",
      heavy: "较重",
      veryHeavy: "非常重",
    },
    teachingLabels: {
      poor: "较差",
      fair: "一般",
      good: "良好",
      veryGood: "很好",
      excellent: "优秀",
    },
    qualityLabels: {
      excellent: "优秀",
      veryGood: "很好",
      good: "良好",
      average: "一般",
      belowAverage: "中下",
      poor: "较差",
    },
    qualityDescriptions: {
      excellent: "这门课程持续获得学生的高度好评。",
      veryGood: "这门课程评分很高，大多数学生都推荐。",
      good: "这门课程普遍获得学生的正面反馈。",
      average: "这门课程的评价褒贬不一。",
      belowAverage: "这门课程的负面评价较多。",
      poor: "根据学生反馈，这门课程存在明显问题。",
    },
  },
};
